import FaceRetouchingOffOutlined from "@mui/icons-material/FaceRetouchingOffOutlined";
import classNames from "classnames";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectCharacterPresets } from "../../app/slices/MetadataSlice";
import { selectSelectedActor, updateActor } from "../../app/slices/TrainingSlice";

/** The face presets as 64px tiles; the first tile is "no preset". */
export default function ActorCharacterPresetSelector() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const selectedActor = useSelector(selectSelectedActor);
  const allPresets = useSelector(selectCharacterPresets);
  const selectedIndex = useMemo(() => {
    return allPresets.findIndex((preset) => preset.preset_name === selectedActor?.preset);
  }, [selectedActor, allPresets]);

  const onPresetClicked = (index: number) => {
    if (!selectedActor) return;
    const newPreset = index > -1 ? allPresets[index].preset_name : "";
    dispatch(updateActor({ ...selectedActor, preset: newPreset }));
  };

  const tile = (index: number, label: string, content: React.ReactNode) => (
    <button
      key={index}
      type="button"
      aria-label={label}
      aria-pressed={selectedIndex === index}
      data-testid={`face-preset-${index}`}
      className={classNames("actorpreseteditor-face", {
        "actorpreseteditor-face--selected": selectedIndex === index,
      })}
      onClick={() => onPresetClicked(index)}
    >
      {content}
    </button>
  );

  return (
    <div className="actorpreseteditor-faces" data-testid="face-presets">
      {tile(-1, String(t("actor_preset_editor.no_face")), <FaceRetouchingOffOutlined fontSize="inherit" />)}
      {allPresets.map((preset, index) =>
        tile(index, preset.preset_name, <img src={"/presets/" + preset.preset_preview} alt="" draggable={false} />)
      )}
    </div>
  );
}
